/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
// import PropTypes from "prop-types";

import React, { useState } from "react";
import BlockContent from "@sanity/block-content-to-react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import tw, { css } from "twin.macro";
import { Button, Go, Image } from "~components";
import * as T from "~styles/Typography.jsx";

const PortableText = ({ blocks, serializer }) => {
  const sanityConfig = { projectId: `pwine8ro`, dataset: `production` };

  const [serializers, setSerializers] = useState({
    types: {
      block: (props) => {
        switch (props.node.style) {
          case `h1`:
            return (
              <T.Head _css={[tw`font-bold`]} font="1" level="2">
                {props.children}
              </T.Head>
            );

          case `h2`:
            return (
              <T.Head _css={[tw`mb-4 font-bold`]} font="2" level="2">
                {props.children}
              </T.Head>
            );

          case `h3`:
            return (
              <T.Head _css={[tw`mb-4 font-bold`]} font="3" level="3">
                {props.children}
              </T.Head>
            );

          case `h4`:
            return (
              <T.Head _css={[tw`mb-3 font-bold`]} font="4" level="4">
                {props.children}
              </T.Head>
            );

          case `h5`:
            return (
              <T.Head _css={[tw`mb-2 font-bold`]} font="5" level="5">
                {props.children}
              </T.Head>
            );

          case `h6`:
            return (
              <T.Head _css={[tw`mb-1 font-bold`]} font="6" level="6">
                {props.children}
              </T.Head>
            );

          case `normal`:
            return (
              <T.Body _css={[tw`mt-4 mb-6`]} font="2" allowHTML={false}>
                {props.children}
              </T.Body>
            );

          case `blockquote`:
            return (
              <blockquote>
                <T.Body _css={[tw`mt-4 mb-6`]} font="1" allowHTML={false}>
                  <span>|</span>
                  <span tw="pl-4">{props.children}</span>
                </T.Body>
              </blockquote>
            );

          default:
            return <></>;
        }
      },

      altImage: (props) => {
        const imageData = getGatsbyImageData(
          props.node.asset._ref,
          { maxWidth: 1024 },
          sanityConfig
        );

        const imageJSX = (
          <Image
            tw="w-full relative block"
            image={imageData}
            alt={props.node.altText}
          />
        );

        return (
          <figure css={[tw`w-full relative block mt-4 mb-16`]}>
            {imageJSX}
          </figure>
        );
      }
    },

    list: ({ children, type }) => {
      let innerJSX = (
        <ol
          css={[
            tw`pl-6 pr-4 md:pr-0 font-body text-b2 md:text-b2-md list-decimal list-outside`
          ]}
        >
          {children}
        </ol>
      );

      if (type === `bullet`) {
        innerJSX = (
          <ul
            css={[
              tw`pl-6 pr-4 md:pr-0 font-body text-b2 md:text-b2-md list-disc list-outside`
            ]}
          >
            {children}
          </ul>
        );
      }

      return (
        <div css={[tw`w-full relative mt-4 mb-6 whitespace-pre-wrap`]}>
          {innerJSX}
        </div>
      );
    },
    listItem: ({ children }) => (
      <li>
        <T.Body font="2" _css={[tw`mb-2`]}>
          {children}
        </T.Body>
      </li>
    ),

    marks: {
      link: ({ children, mark }) => {
        if (mark?.newTab) {
          return (
            <a href={mark.href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        }

        return <a href={mark.href}>{children}</a>;
      },
      button: ({ children, mark }) => {
        if (mark.internal) {
          return (
            <Go to={mark.url} className="article-button" _css={[tw`py-4 px-8`]}>
              <Button _css={[tw`h-12 mt-8`]} text={children} transparent />
            </Go>
          );
        }
        return (
          <a
            href={mark.url}
            rel="noopener noreferrer"
            target="_blank"
            className="article-button"
          >
            <Button _css={[tw`h-12 mt-8`]} text={children} transparent />
          </a>
        );
      }
    }
  });

  //

  return (
    <BlockContent
      css={[
        css`
          //
        `
      ]}
      blocks={blocks}
      serializers={serializer || serializers}
    />
  );
};

export default PortableText;
